import _extends from "@babel/runtime/helpers/extends";
import React, { PureComponent, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
export default class ModalTrigger extends PureComponent {
  static propTypes = {
    Modal: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
  };
  state = {
    visible: false
  };
  toggleVisible = visible => () => {
    this.setState({
      visible
    });
  };
  render() {
    const {
      visible
    } = this.state;
    const {
      Modal,
      children,
      ...props
    } = this.props;
    const close = this.toggleVisible(false);
    const open = this.toggleVisible(true);
    const trigger = Children.only(children);
    const {
      props: {
        onClick: onClickTrigger
      }
    } = trigger;
    const onClick = () => {
      if (onClickTrigger) {
        onClickTrigger(open);
      } else {
        open();
      }
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/cloneElement(trigger, {
      onClick
    }), /*#__PURE__*/React.createElement(Modal, _extends({
      close,
      visible
    }, props, {
      onClose: close
    })));
  }
}
//# sourceMappingURL=index.js.map